import React, { useState } from 'react'
import { createUseStyles } from 'react-jss'

import { MdVisibility, MdVisibilityOff, MdCheckBox, MdCheckBoxOutlineBlank, MdErrorOutline } from "react-icons/md"
import SyncLoader from 'react-spinners/SyncLoader'

import View from '../form/View'
import InputField from '../form/InputField'
import Switch from '../form/Switch'
import Button from '../form/Button'

import DispatchService from '../../services/DispatcherService'

const logo = require('../../assets/logo.png')
const useStyles = createUseStyles(theme => ({
  content: {
    flex: 1,
    justifyContent: 'space-between',
    flexDirection: 'column',
    overflowX: 'hidden',
    padding: '32px',

    '@media(min-width: 500px)': {
      background: '#ffffff',
      position: 'relative',
      flex: 'none',
      width: '100%',
      maxWidth: '400px',
      minHeight: '600px',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
      borderRadius: '16px',
      zIndex: 10,
    }
  },
  logo: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  logoImg: {
    width: '60%',
    objectFit: 'contain'
  },
  title: {   
    fontFamily: 'Fira Sans, sans serif',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '32px',
    color: '#454545',
    margin: '20px 0 0',
  },
  message: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    color: '#454545',
    margin: '20px 0 0',
  },
  email: {
    color: theme.colors.secondary
  },
  form: {
    flexDirection: 'column',
    margin: '20px 0',
  },
  feedback: {
    backgroundColor: '#F9F9FA',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '18px'
  },
  feedbackIcon: {
    marginRight: '18px'
  },
  feedbackMessage: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    color: '#F6A609'
  },
  link: {
    color: theme.colors.secondary
  }
}))

function SignupForm (props) {

  const managerConfig = DispatchService.getManagerConfig();
  const domain = managerConfig.domain;
    
  const styles = useStyles()
  const theme = {
    colors: {
      primary: '#1040C6',
      secondary: '#00BDFF'
    }
  }

  const [ name, setName ] = useState('')
  const [ pwd0, setPwd0 ] = useState('')
  const [ pwd1, setPwd1 ] = useState('')
  
  const [ nameError, setNameError ] = useState(null)
  const [ pwdError, setPwdError ] = useState(null)
  const [ feedbackError, setFeedbackError ] = useState(false)

  const [ showPassword, setShowPassword ] = useState(false)
  const [ checked, setChecked ] = useState(false)

  const onSubmit = async () => {
    try {
      if (name === '') {
        setNameError('Preencha o campo com o seu nome completo')
        throw new Error('Formulário preenchido de forma inválida')
      }

      const regex = /^[A-zÀ-ú\s]*$/
      if (!name.match(regex)) {
        setNameError('O campo não pode conter números ou caracteres especiais.')
        throw new Error('Formulário preenchido de forma inválida')
      }

      setNameError(null)

      if (pwd0 !== pwd1) {
        setPwdError('As senhas não são iguais. Tente novamente')
        throw new Error('Formulário preenchido de forma inválida')
      } else if (pwd0.length < 8) {
        setPwdError('Use entre 8 e 15 caracteres para a senha')
        throw new Error('Formulário preenchido de forma inválida')
      }
      setPwdError(null)

      if (!checked) {
        setFeedbackError(true)
        throw new Error('Formulário preenchido de forma inválida')
      }

      setFeedbackError(false)
    
      props.onSubmit(name, pwd0)
    } catch (err) {
      console.error(err)
    }
  }

  const labelStyles = { fontSize: '18px' }
  const descriptionStyles = { fontSize: '12px'}
  const errorStyles = { fontSize: '12px'}
  const pwdInputType = showPassword ? 'text' : 'password'
  
  return (
    <View className={styles.content}>
      <View className={styles.logo}>
        <img src={logo} alt="Logo" className={styles.logoImg} />
      </View>
      <View className={styles.title}>
        Crie sua conta
      </View>
      <View className={styles.message}>
        <span>Nós precisamos de algumas informações para completar o cadastro da sua conta associada ao e-mail <span className={styles.email}>{DispatchService.getEmailFromURL()}</span></span>
      </View>
      { feedbackError && 
        <View className={styles.feedback}>
          <View className={styles.feedbackIcon}>
            <MdErrorOutline size='24px' color='#F6A609' />
          </View>
          <View className={styles.feedbackMessage}>
            Para continuar, é necessário aceitar os Termos de Uso
          </View>
        </View>
      }

      <View className={styles.form}>
        <InputField
          label="Nome completo"
          customStyles={{ padding: 0 }}
          labelStyles={labelStyles}
          errorStyles={errorStyles}
          value={name}
          onChange={e => setName(e.target.value)}
          error={nameError}
        />

        <InputField
          label="Senha"
          description="8 a 15 caracteres"
          customStyles={{ padding: 0, margin: 0 }}
          labelStyles={labelStyles}
          descriptionStyles={descriptionStyles}
          hideFeedback={true}
          type={pwdInputType}
          value={pwd0}
          onChange={e => setPwd0(e.target.value)}
          error={pwdError}
        />
        
        <InputField
          customStyles={{ padding: 0, margin: 0 }}
          type={pwdInputType}
          value={pwd1}
          onChange={e => setPwd1(e.target.value)}
          error={pwdError}
          errorStyles={errorStyles}
        />

        <Switch
          icon={showPassword ? <MdVisibility size='24px' color={theme.colors.primary}/> : <MdVisibilityOff size='24px' color={'#828282'}/>}
          value={showPassword}
          onChange={setShowPassword}
          label={"Mostrar senha"}
        />

        <Switch
          icon={checked ? <MdCheckBox size='24px' color={theme.colors.primary}/> : <MdCheckBoxOutlineBlank size='24px' color={'#828282'}/>}
          value={setChecked}
          onChange={setChecked}
          label={<>Li e concordo com os <a className={styles.link} href={`https://${domain}/site/termos-de-uso.html`} target="_blank" rel="noopener noreferrer">Termos de Uso e Política de Privacidade</a>.</>}
        />

        <Button 
          label={ props.fetching ? <SyncLoader color="#fff" size="10" /> : "Criar conta" }
          onClick={onSubmit}
          disabled={props.fetching}
        />
      </View>
    </View>
  )
}

export default SignupForm